import { render, staticRenderFns } from "./AccountTypeCard.vue?vue&type=template&id=47db0c4c"
import script from "./AccountTypeCard.vue?vue&type=script&lang=js"
export * from "./AccountTypeCard.vue?vue&type=script&lang=js"
import style0 from "./AccountTypeCard.vue?vue&type=style&index=0&id=47db0c4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports